export const getCategoryGame = state => state.categoryGame.game;